import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IFormValidationError } from '../../eo-form/eo-form.config';

@Component({
  selector: 'eo-validation-error-msg',
  templateUrl: './eo-validation-error-msg.component.html',
  styleUrl: './eo-validation-error-msg.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoValidationErrorMsgComponent),
      multi: true,
    },
  ],
})
export class EoValidationErrorMsgComponent {
  @Input() formControl?: FormControl<any>;
  @Input() errors? :IFormValidationError;

  showErrorMsg(validatorFnName: string) {
    return (
      this.formControl?.touched && this.formControl?.hasError(validatorFnName)
    );
  }

  // implement ControlValueAccessor start ------------------
  writeValue(obj: any): void {}
  registerOnChange(fn: any): void {}
  registerOnTouched(fn: any): void {}
  // implement ControlValueAccessor end ------------------
}
